export const checkFormHasError = error => {
  if (!Object.keys(error).length) {
    return false;
  }
  const errorKey = Object.keys(error).find(key => {
    const errorArray = error[key];

    return Array.isArray(errorArray) ? !!errorArray.length : false;
  });

  return errorKey !== -1;
};

export const getErrorFromErrorObj = (errors, name) => {
  const errorArr = errors[name] || [];

  if (errorArr.length) {
    return errorArr.toString();
  }

  return '';
};
